import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { TasasService } from './tasas.service';
import { SolicitudTasasViewModel } from './tasas.types';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { EnumCodigosTwTcAcciones, EnumIdsTcEstadoSolicitud, EnumIdsTwTcTipoClonacion } from '../types/enum';
import { TTasaViewModel, TcPerfilUsuarioEnum } from 'src/app/components/core/_infrastructure/types/common';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-tasas',
    templateUrl: './tasas.component.html',
})
export class TasasComponent extends ComponentBase implements OnInit {
    solicitudTasas: SolicitudTasasViewModel;
    habilitarGuardar = true;
    habilitarEdicion = true;
    visibilitySpinner = false;
    tituloTipoSolicitud: string;
    IdEstadoSolicitud: number;
    tituloEstadoSolicitud: string;
    laHeGrabadoYo = false;
    esClonada = false;
    numeroTasas = 0;
    IdTipoSolicitud: number;
    idSolicitud: number;

    colsTasas: any[];

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private tasasService: TasasService,
        private navMenuService: NavMenuService,
        private solicitudService: SolicitudService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudTasas = new SolicitudTasasViewModel();
    }

    ngOnInit() {
        this.idSolicitud = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitud);

        this.createForm();

        //Siempre tendrá un id
        if (this.idSolicitud) {
            this.loading = true;

            //Para saber si se actua como Inspector o Grabador
            let params = new HttpParams();
            params = params.append('idSolicitud', this.idSolicitud.toString());
            params = params.append('idUsuario', this.loggedInUser!.Id.toString());
            this.solicitudService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
                this.laHeGrabadoYo = resultIsGrabada;

                //recuperar la solicitud
                this.tasasService.getSolicitudTasas(this.idSolicitud).subscribe(result => {
                    this.solicitudTasas = result;

                    this.IdTipoSolicitud = this.solicitudTasas.IdTipoSolicitud;
                    this.IdEstadoSolicitud = this.solicitudTasas.IdEstadoSolicitud;
                    this.tituloTipoSolicitud = this.solicitudTasas.IdTipoSolicitudDescripcion;
                    this.tituloEstadoSolicitud = this.solicitudTasas.IdEstadoSolicitudDescripcion;

                    this.esClonada =
                        this.solicitudTasas.TwSolicitudJerarquia != null &&
                        this.solicitudTasas.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;
                    //SI ES RE-IMPORTACION
                    if (this.solicitudTasas.EsReImportacion) {
                        this.tituloTipoSolicitud += ' - Re-Importación';
                    }
                    //SI ES PREVIA
                    if (this.solicitudTasas.EsPrevia) {
                        if (
                            this.solicitudTasas.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                            this.solicitudTasas.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitud += ' - Previa';
                        }
                    }

                    this.updateForm();

                    this.numeroTasas = this.solicitudTasas.TTasaCollection.length;

                    this.loading = false;

                    //Si soy Grabador
                    if (
                        this.isGrabador &&
                        this.solicitudTasas.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE
                    ) {
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD, this.solicitudTasas.IdEstadoSolicitud).Visible &&
                            this.laHeGrabadoYo;
                        this.habilitarEdicion =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_TASAS, this.solicitudTasas.IdEstadoSolicitud).Editable &&
                            this.laHeGrabadoYo;
                    } else {
                        this.habilitarGuardar = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD,
                            this.solicitudTasas.IdEstadoSolicitud,
                        ).Visible;
                        this.habilitarEdicion = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.MENU_TASAS,
                            this.solicitudTasas.IdEstadoSolicitud,
                        ).Editable;
                    }

                    if (!this.habilitarEdicion) {
                        //metodo para deshabilitar los controles
                        this.DisableControlsConsulta();
                    }
                });
            });
        }

        this.colsTasas = [
            { field: 'Link', header: '' },
            { field: 'TotalTasas', header: 'Importe Tasa (€)' },
            { field: 'FechaLiquidacion', header: 'Fecha Liquidación' },
            { field: 'NumeroLiquidacion', header: 'Nº Liquidación' },
        ];
    }

    private DisableControlsConsulta() {
        this.form.controls['TotalTasas'].disable();
        this.form.controls['FechaLiquidacion'].disable();
        this.form.controls['NumeroLiquidacion'].disable();
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            TotalTasas: '',
            FechaLiquidacion: '',
            NumeroLiquidacion: '',
        });
    }

    updateForm() {
        this.form.setValue({
            TotalTasas: '',
            FechaLiquidacion: '',
            NumeroLiquidacion: '',
        });
    }

    onAddTasa() {
        this.removeValidators('TotalTasas');
        this.addValidator('TotalTasas', Validators.required);
        this.addValidator('TotalTasas', Validators.pattern('^[0-9]+([.,][0-9]+)?$'));
        if (this.isFieldInvalidNoSubmit('TotalTasas', 'required') || this.isFieldInvalidNoSubmit('TotalTasas', 'pattern')) {
            return;
        }
        this.removeValidators('TotalTasas');

        this.removeValidators('NumeroLiquidacion');
        this.addValidator('NumeroLiquidacion', Validators.pattern('^[0-9]+([.,][0-9]+)?$'));
        if (this.isFieldInvalidNoSubmit('NumeroLiquidacion', 'pattern')) {
            return;
        }
        this.removeValidators('NumeroLiquidacion');

        if (this.form.value.TotalTasas != '') {
            let tasa = new TTasaViewModel();

            tasa.TotalTasas = this.form.value.TotalTasas;
            tasa.NumeroLiquidacion = this.form.value.NumeroLiquidacion;
            tasa.FechaLiquidacion = this.form.value.FechaLiquidacion;

            //Convierto las comas en puntos
            tasa.TotalTasas = Number(tasa.TotalTasas.toString().replace(',', '.'));

            //this.solicitudTasas.TTasaCollection.push(tasa);
            //RDLF-->cambia la forma de introducir elementos al array para que refresque la p-tabla
            this.solicitudTasas.TTasaCollection = [...this.solicitudTasas.TTasaCollection, tasa];

            this.numeroTasas = this.solicitudTasas.TTasaCollection.length;
        }

        this.form.patchValue({
            TotalTasas: '',
            NumeroLiquidacion: '',
            FechaLiquidacion: '',
        });
    }

    onDeleteTasa(tasa: TTasaViewModel) {
        //this.solicitudTasas.TTasaCollection.splice(this.solicitudTasas.TTasaCollection.indexOf(tasa), 1);
        //RDLF-->cambia la forma de eliminar elementos al array para que refresque la p-tabla
        this.solicitudTasas.TTasaCollection = [
            ...this.solicitudTasas.TTasaCollection.slice(0, this.solicitudTasas.TTasaCollection.indexOf(tasa)),
            ...this.solicitudTasas.TTasaCollection.slice(this.solicitudTasas.TTasaCollection.indexOf(tasa) + 1),
        ];

        this.numeroTasas = this.solicitudTasas.TTasaCollection.length;
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/datosbasicos', this.solicitudTasas.Id]);
    }

    guardarTasas() {
        this.confirmationService.confirm({
            message: '¿Está seguro de guardar las tasas de la solicitud?',
            accept: () => {
                this.onSubmit();
            },
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }
        //if (this.solicitudTasas.TTasaCollection.length == 0) {
        //    this.addErrorMessage("No ha añadido ninguna tasa");
        //    return;
        //}

        this.visibilitySpinner = true;

        let solicitudTasas = new SolicitudTasasViewModel();

        solicitudTasas.TTasaCollection = this.solicitudTasas.TTasaCollection;
        solicitudTasas.IdEstadoSolicitud = this.solicitudTasas.IdEstadoSolicitud;
        solicitudTasas.Id = this.solicitudTasas.Id;

        if (this.solicitudTasas.FechaCreacion != null) {
            solicitudTasas.FechaCreacion = this.solicitudTasas.FechaCreacion;
        }

        this.tasasService.editSolicitudTasas(solicitudTasas).subscribe({
            next: res => {
                this.addSuccessMessage('Tasas guardadas correctamente');
                //this.onBack();
                this.visibilitySpinner = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinner = false;
            },
        });
    }
}
